import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/* Components */
import { PlatformModule } from '@app/platform.module';
import { BenefitsService } from '@benefits/services/benefits.service';
import { AppCommonModule } from '@common/common.module';
import { ReportDataResolver } from '@reporting/report-data.resolver';
import { ReportingResolver } from '@reporting/reporting.resolver';
/* Common Modules */
import { PerformanceRouterModule } from '@reporting/reporting.routes';
import { CustomReportingService } from '@reporting/services/custom-reporting.service';
import { ReportingService } from '@reporting/services/reporting.service';
import { Views } from '@reporting/views';
import { ReportingFormsModule } from '../forms/reporting/reporting-forms-module';
import { TableModule } from '../table/table.module';
import { Components } from './components';
import { ReportingCardComponent } from './components/card/reporting-card.component';
import { Services } from './services';
import { JournalEntryReportService } from './services/journal-entry-report.service';
import { VacationYTDBalancesReportService } from './services/vacation-ytd-balances-report.service';

@NgModule({
    imports: [
        PerformanceRouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppCommonModule,
        ReportingFormsModule,
        PlatformModule,
        TableModule,
        ReportingCardComponent,
    ],
    declarations: [
        /* Views */
        ...Views,
        /* Components */
        ...Components,
    ],
    providers: [
        ReportingService,
        CustomReportingService,
        JournalEntryReportService,
        ReportingResolver,
        ReportDataResolver,
        BenefitsService,
        VacationYTDBalancesReportService,
        ...Services,
    ],
})
export class ReportingModule {}
